var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenizedVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88068 40H32.1231C33.1272 40 33.9413 39.1859 33.9413 38.1818V17.5758C33.9413 16.5716 33.1272 15.7576 32.1231 15.7576H30.3049V10.303C30.3049 4.62194 25.683 0 20.0019 0C14.3208 0 9.69886 4.62194 9.69886 10.303V15.7576H7.88068C6.87656 15.7576 6.0625 16.5716 6.0625 17.5758V38.1818C6.0625 39.1859 6.87656 40 7.88068 40ZM21.8201 28.4832V30.9091C21.8201 31.9132 21.006 32.7273 20.0019 32.7273C18.9978 32.7273 18.1837 31.9132 18.1837 30.9091V28.4832C17.4482 27.9298 16.9716 27.0499 16.9716 26.0606C16.9716 24.3897 18.331 23.0303 20.0019 23.0303C21.6728 23.0303 23.0322 24.3897 23.0322 26.0606C23.0322 27.0499 22.5556 27.9298 21.8201 28.4832ZM13.3352 10.303C13.3352 6.62703 16.3259 3.63636 20.0019 3.63636C23.6779 3.63636 26.6686 6.62703 26.6686 10.303V15.7576H13.3352V10.303Z",
    fill: "#6D77A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenizedVault);
export default __webpack_public_path__ + "static/media/Tokenized Vault.d82364eead12ac874a72165504963aba.svg";
export { ForwardRef as ReactComponent };